import baseAPI from './axiosApi'

const api={
    list:'/api-ir/hr/payroll/list',
    add:'/api-ir/hr/payroll/add',
    del:'/api-ir/hr/payroll/delete',
    export:'/api-ir/hr/payroll/export',
    edit:'/api-ir/hr/payroll/edit',
    approved:'/api-ir/hr/payroll/approved',

}

export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}

export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}

export function exportFile (data) {
    return baseAPI.axiosData(api.export,'get',data)
}

export function del (data) {
    return baseAPI.axiosData(api.del,'post',data)
}

export function approved (data) {
    return baseAPI.axiosData(api.approved,'post',data)
}

export function edit (data) {
    return baseAPI.axiosData(api.edit,'put',data)
}